//import { CAD_STATS_API_URL } from "config/backend";
import { CANTO } from "config/chains";
//import { bigNumberify } from "lib/numbers";
import {  getServerUrl } from "config/backend";
import { arrayURLFetcher } from "lib/legacy";
import useSWR from "swr";
//import { resolve } from "node:path/posix";
const ACTIVE_CHAIN_IDS = [CANTO];

// export function useVolumeInfo() {
//   const url = getServerUrl(CANTO, "/api/total_volume");
//   console.log(url, 'url')

//   const { data } = useSWR(
//     url,
//     async (url) => {
//       const res = await fetch(url);
//       //console.log(JSON.stringify(), 'res')

//       const json = await res.json();
//       console.log(json, 'json')
//       return {
//         [CANTO]: bigNumberify(json[CANTO]),
//         total: bigNumberify(json.total),
//       };
//     },
//     {
//       refreshInterval: 60000,
//     }
//   );

//   return data;
// }

export function useVolumeInfo() {
  const { data: totalVolume } = useSWR<any>(
    ACTIVE_CHAIN_IDS.map((chain) => getServerUrl(chain, "/api/daily_volume")),
    {
      fetcher: arrayURLFetcher,
    }
  );
  
  return totalVolume ? totalVolume : undefined;
}
